var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/bar-chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 4.5V28.5C4.5 29.2956 4.81607 30.0587 5.37868 30.6213C5.94129 31.1839 6.70435 31.5 7.5 31.5H31.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 25.5V21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5 25.5V13.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27 25.5V7.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatChart);
export default __webpack_public_path__ + "static/media/stat_chart.dc6142a06a02662e87d24a5590d79c0b.svg";
export { ForwardRef as ReactComponent };